console.log('hola')

var whatsappRedirect = (e) => {
    e.preventDefault();
    if(!e.target.classList.value.includes('closeMessages__button')){

        fetch('//truccos.com.co/cdn/shop/t/107/assets/emojis.json?v=109438767582426176141787863360')
            .then((res) => res.json())
            .then((data) => {
                const whatsAppDispatcherValues = data;
                const whatsAppOrganicValues = data.organic;
                const whatsAppUtmsValues = data.utms;
                let selectedNumber = '+573148651454';
    
                const whatsAppMessageUrl = `https://api.whatsapp.com/send?phone=${selectedNumber}&text=`;
                let whatsAppEmoji = whatsAppDispatcherValues.direct || '';


                // get query params
                const queryString = window.location.search.substring(1);
                const urlParams = new URLSearchParams(queryString);
                let locationHref = sessionStorage.getItem("locationHref");
                let utm_source = sessionStorage.getItem("utm_source");
                let utm_medium = sessionStorage.getItem("utm_medium");
                // get product / landing data
                const productForm = document.querySelector('.template-product');
                let productFormValue = productForm
                    ? productForm.querySelector('[name="id"]').value || ""
                    : "";
                const landingTitle = window.ShopifyAnalytics
                    ? window.ShopifyAnalytics.meta
                    ? window.ShopifyAnalytics.meta.product
                        ? window.ShopifyAnalytics.meta.product.variants
                        ? window.ShopifyAnalytics.meta.product.variants.find(
                            (p) => p.id === +productFormValue
                            ).name || null
                        : null
                        : window.ShopifyAnalytics.meta.page
                        ? window.ShopifyAnalytics.meta.page.pageType === "page"
                        ? document.title
                        : null
                        : null
                    : null
                    : null;
    
                // get referrer
                const getReferrer = document.referrer;
              
                if (!!utm_source && !!utm_medium) {
                    whatsAppEmoji = whatsAppUtmsValues.filter((item) => {
                       //console.log(item.utm_source.toLowerCase()+' == '+ utm_source.toLowerCase())
                      //console.log(item.utm_medium.toLowerCase()+' == '+ utm_medium.toLowerCase())
                    return (
                       item.utm_source.toLowerCase().trim() ===
                                utm_source.toLowerCase().trim() &&
                            item.utm_medium.toLowerCase().trim() ===
                                utm_medium.toLowerCase().trim()
                    );
                    })[0];
                    if (whatsAppEmoji) {
                      whatsAppEmoji = whatsAppEmoji.name.split("-");
                    }else{
                       whatsAppEmoji = whatsAppDispatcherValues.direct;
                    }
                  
                } else if (getReferrer) {
                    whatsAppEmoji = whatsAppOrganicValues.filter((item) => {
                    return getReferrer.toLowerCase().includes(item.source.toLowerCase());
                    });
                    if (!whatsAppEmoji.length) {
                    whatsAppEmoji = whatsAppDispatcherValues.direct;
                    } else {
                    whatsAppEmoji = whatsAppEmoji[0].name.split("-");
                    }
                }
              
                let whatsAppBaseMessage = "";
                if (landingTitle) {
                    whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola! Trucco's Jeans  +vengo de la página: +${encodeURIComponent(landingTitle).replace(/%20/g,"+")}+y quiero recibir asesoría!`;
                    if(window.ShopifyAnalytics.meta.product){
                      whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola! Trucco's Jeans  +me interesa este producto:+${encodeURIComponent(landingTitle).replace(/%20/g,"+")}%21`;
                    }
                } else{
                    whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola Trucco's Jeans , quiero recibir asesoría!`;                
                }
                  window.location.href = `${whatsAppMessageUrl}${whatsAppBaseMessage}`;
                // window.location.href = 'https://wa.me/573043610747'
        })
        .catch((err) => console.error(err));
    }
};

var urlWhatsapp = '';
var urlWhatsappSiste = '';

function whatsappRedirectURL (){

    fetch('//truccos.com.co/cdn/shop/t/107/assets/emojis.json?v=109438767582426176141787863360')
        .then((res) => res.json())
        .then((data) => {
            const whatsAppDispatcherValues = data;
            const whatsAppOrganicValues = data.organic;
            const whatsAppUtmsValues = data.utms;
            let selectedNumber = '+573176985237';
            const whatsAppMessageUrl = `https://api.whatsapp.com/send?phone=${selectedNumber}&text=`;
            let whatsAppEmoji = whatsAppDispatcherValues.direct || '';


            // get query params
            const queryString = window.location.search.substring(1);
            const urlParams = new URLSearchParams(queryString);
            let locationHref = sessionStorage.getItem("locationHref");
            let utm_source = sessionStorage.getItem("utm_source");
            let utm_medium = sessionStorage.getItem("utm_medium");
            // get product / landing data
            const productForm = document.querySelector('.template-product');
            let productFormValue = productForm
                ? productForm.querySelector('[name="id"]').value || ""
                : "";
            const landingTitle = window.ShopifyAnalytics
                ? window.ShopifyAnalytics.meta
                ? window.ShopifyAnalytics.meta.product
                    ? window.ShopifyAnalytics.meta.product.variants
                    ? window.ShopifyAnalytics.meta.product.variants.find(
                        (p) => p.id === +productFormValue
                        ).name || null
                    : null
                    : window.ShopifyAnalytics.meta.page
                    ? window.ShopifyAnalytics.meta.page.pageType === "page"
                    ? document.title
                    : null
                    : null
                : null
                : null;

            // get referrer
            const getReferrer = document.referrer;
          
            if (!!utm_source && !!utm_medium) {
                whatsAppEmoji = whatsAppUtmsValues.filter((item) => {
                   //console.log(item.utm_source.toLowerCase()+' == '+ utm_source.toLowerCase())
                  //console.log(item.utm_medium.toLowerCase()+' == '+ utm_medium.toLowerCase())
                return (
                   item.utm_source.toLowerCase().trim() ===
                            utm_source.toLowerCase().trim() &&
                        item.utm_medium.toLowerCase().trim() ===
                            utm_medium.toLowerCase().trim()
                );
                })[0];
                if (whatsAppEmoji) {
                  whatsAppEmoji = whatsAppEmoji.name.split("-");
                }else{
                   whatsAppEmoji = whatsAppDispatcherValues.direct;
                }
              
            } else if (getReferrer) {
                whatsAppEmoji = whatsAppOrganicValues.filter((item) => {
                return getReferrer.toLowerCase().includes(item.source.toLowerCase());
                });
                if (!whatsAppEmoji.length) {
                whatsAppEmoji = whatsAppDispatcherValues.direct;
                } else {
                whatsAppEmoji = whatsAppEmoji[0].name.split("-");
                }
            }
          
            let whatsAppBaseMessage = "";
            let whatsAppBaseMessageSiste = "";
            if (landingTitle) {
                whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola!+vengo de la página: +${encodeURIComponent(landingTitle).replace(/%20/g,"+")}+y quiero recibir asesoría!`;
                if(window.ShopifyAnalytics.meta.product){
                  whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola! Atenea +me interesa este producto:+${encodeURIComponent(landingTitle).replace(/%20/g,"+")}%21`;
                  whatsAppBaseMessageSiste = `%C2%A1${whatsAppEmoji}Hola Atenea, quiero crédito con sistecrédito para llevar el producto +${encodeURIComponent(landingTitle).replace(/%20/g,"+")}%21`;
                }
            } else{
                whatsAppBaseMessage = `%C2%A1${whatsAppEmoji}Hola Atenea, quiero recibir asesoría!`;                
            }
            urlWhatsapp = `${whatsAppMessageUrl}${whatsAppBaseMessage}`;
            urlWhatsappSiste = `${whatsAppMessageUrl}${whatsAppBaseMessageSiste}`;
            // window.location.href = 'https://wa.me/573043610747'
    })
    .catch((err) => console.error(err));

};

whatsappRedirectURL();

var whatsAppFloatingButton = document.getElementById("whatsAppFloatingButton");
var whatsappProduct = $(".container-whatsapp-btn a");

window.addEventListener("load", async function () {

    fetch('//truccos.com.co/cdn/shop/t/107/assets/emojis.json?v=109438767582426176141787863360')
    .then((response) => response.json())
    .then((valuesJson) => {
      // get query params
    const locationHref = window.location.href;
    const queryString = window.location.search.substring(1);
    const urlParams = new URLSearchParams(queryString);
    let utm_source = urlParams.get("utm_source");
    let utm_medium = urlParams.get("utm_medium");
    
    !sessionStorage.getItem("locationHref") && sessionStorage.setItem("locationHref", locationHref);
    utm_source && sessionStorage.setItem("utm_source", utm_source);
    utm_medium && sessionStorage.setItem("utm_medium", utm_medium);
  
    if (!!utm_source && !!utm_medium) {
    const emojiFounded = valuesJson.utms.filter((item) => {
        return (
          item.utm_source.toLowerCase().trim() ===
                utm_source.toLowerCase().trim() &&
            item.utm_medium.toLowerCase().trim() ===
                utm_medium.toLowerCase().trim()
        );
    })[0];

      
    if (!emojiFounded || emojiFounded === undefined) {
        whatsAppFloatingButton.setAttribute(
        "data-source",
        `error-${utm_source}`
        );
        whatsAppFloatingButton.setAttribute(
        "data-medium",
        `error-${utm_medium}`
        );
        whatsAppFloatingButton.classList.add("error-utm");
    }
    }
    whatsAppFloatingButton?.addEventListener("click", whatsappRedirect);
    $(whatsappProduct).attr('href' , urlWhatsapp )
    $('.btn-whatsapp').attr('href' , urlWhatsapp )
    $('.btn-sistecredito').attr('href' , urlWhatsappSiste )
    $('.btn-sistecredito').on("click", function() {
      window.location.href = urlWhatsappSiste;
    })
});
});
